import axios from "axios";

var MedicationMonograph = {
    initializeHeaders: function (headers) {
        axios.defaults.headers.common = headers;
    },
    get: function (ndc, params) {
        return axios.get(
            Apollo.resolveApiUrl("~/monograph/" + ndc),
            {
                params: params

            });
    }
};

export default MedicationMonograph;


// WEBPACK FOOTER //
// ./src/models/MedicationMonograph.js